import React from 'react'

export default function FaceFeature({ scaleX, fill, outline, verticalOffset }) {
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <path
        d="M42.8201 25.7483C39.5201 31.7383 31.2401 39.7782 31.2401 39.7782L25.2101 36.4182L19.6001 39.7782C19.6001 39.7782 11.4401 34.3382 7.73009 27.0482C6.29009 24.2182 2.08008 10.1682 2.08008 10.1682C3.70008 31.0482 9.51008 44.6483 13.8301 48.2283C17.3501 51.1383 22.1301 51.5782 25.2001 51.5782C28.2701 51.5782 33.0501 51.1383 36.5701 48.2283C40.8901 44.6483 46.7001 31.0482 48.3201 10.1682C48.3101 10.1782 44.3501 22.9683 42.8201 25.7483Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M19.68 39.4583C19.45 48.0483 19.75 50.7582 19.75 50.7582"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M16.2705 37.4583C16.0205 40.8583 16.0205 44.8282 16.4705 49.2782"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M22.7301 37.8082C22.6601 42.0882 22.7701 46.7983 23.2601 51.3683"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M12.0705 33.4482C11.5005 36.3682 11.0205 39.9583 10.9805 43.8783"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M9.33032 29.7283C8.74032 31.6283 8.11033 33.8782 7.59033 36.1982"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M7.75043 27.4683C7.01043 29.7083 6.28043 31.9883 5.94043 33.2483"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M5.78023 22.1982C5.33023 24.6182 4.90023 27.6883 4.74023 31.0883"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M30.6999 39.4583C30.9299 48.0483 30.6299 50.7582 30.6299 50.7582"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M34.0702 36.8583C34.3602 40.3983 34.4002 44.5682 33.9102 49.2882"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M27.6501 37.7183C27.7301 42.0283 27.6101 46.7683 27.1201 51.3683"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M38.1001 32.3683C38.7601 35.4583 39.3601 39.4583 39.4101 43.8783"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M40.8501 29.0682C41.4901 31.0982 42.2101 33.5982 42.7901 36.1882"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M42.3604 26.6382C43.1904 29.1282 44.0604 31.8283 44.4404 33.2483"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M44.5801 22.0482C45.0401 24.4982 45.4801 27.6183 45.6401 31.0983"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
    </g>
  )
}
